<template>
    <div class="custom-dropdown" :tabindex="tabindex" @blur="open = false">
        <div class="d-flex">
            <div class="items" :class="{ open: open }">
                <div
                    v-for="(option, i) of ids"
                    :key="i"
                    :class="{ active: selected == ids[i] }"
                    @click="
                        selected = options[i];
                        open = false;
                        $emit('input', { id: ids[i], offset: offsets[i] });
                    "
                >
                    <span><span>{{ options[i] }}</span></span>
                </div>
            </div>
            <div class="drawer" @click="open = !open"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            required: true,
        },
        ids: {
            type: Array,
            required: true,
        },
        offsets: {
            type: Array,
            required: true,
        },
        selected: {
            type: String,
            required: false,
            default: null,
        },
        default: {
            type: String,
            required: false,
            default: null,
        },
        tabindex: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    data() {
        return {
            selected: this.default
                ? this.default
                : this.options.length > 0
                ? this.options[0]
                : null,
            open: false,
        };
    },
    mounted() {
        this.$emit('input', this.selected);
    },
};
</script>

<style scoped>
.custom-dropdown {
    position: relative;
    width: calc(100% - 74px);
    outline: none;
    line-height: 60px;
}
.custom-dropdown .drawer {
    width: 40px;
    height: 60px;
    background: transparent
        url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="8" viewBox="0 0 15 8"><path d="M6.77.778a1,1,0,0,1,1.459,0l5.192,5.538A1,1,0,0,1,12.692,8H2.308a1,1,0,0,1-.73-1.684Z" fill="%23f8c222"/></svg>')
        center center no-repeat;
}
.custom-dropdown .items {
    max-height: 60px;
    overflow: hidden;
    transition: height 0.33s;
}
.custom-dropdown .items.open {
    max-height: 300px;
}
.custom-dropdown .items.open + .drawer {
    transform: rotate(180deg);
}
.custom-dropdown .items div {
    height: 60px;
    text-align: center;
}
.custom-dropdown .items div span {
    height: 60px;
    width: 100%;
    font-weight: bold;
    color: #30368c;
    cursor: pointer;
    user-select: none;

    white-space: nowrap;
    /* text-overflow: ellipsis;
    display: inline-block;*/
    overflow: hidden; 
}
.custom-dropdown .items div.active span span {
    width: auto;
    height: 60px;
    display: inline-block;
    border-bottom: 2px solid #f8c222;
    color: #30368c;
}
.custom-dropdown .items div:not(.active):hover span {
    color: #2da7df;
}
</style>
